// src/pages/Contact.jsx
import React, { useState } from 'react';
import Navbar from '../components/LandingPage-main/Navbar';
import Footer from '../components/PlumPlusDash/Footer';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [confirmation, setConfirmation] = useState('');

  const handleChange = (e) => {
    setFormData({...formData, [e.target.id]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simuler l'envoi du formulaire
    console.log(formData);
    setConfirmation(`Votre message a bien été envoyé. Merci, ${formData.name} !`);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-grow container mx-auto px-4 py-9">
        <h1 className="text-3xl font-bold mb-4 text-primary">Contactez-nous</h1>
        <p className="mb-6">Une question ? Besoin d’assistance ou d’informations complémentaires ? Remplissez le formulaire ci-dessous, et nous vous répondrons sous 48h.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block text-left mb-1 font-semibold">Nom :</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Votre nom complet"
              required
              className="w-full p-3 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-left mb-1 font-semibold">Email :</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Votre email"
              required
              className="w-full p-3 border border-gray-300 rounded-lg"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-left mb-1 font-semibold">Message :</label>
            <textarea
              id="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Expliquez-nous votre situation ou question"
              required
              rows="5"
              className="w-full p-3 border border-gray-300 rounded-lg"
            ></textarea>
          </div>
          <button type="submit" className="btn btn-accent">Envoyer</button>
        </form>
        {confirmation && <p className="mt-4 text-green-500">{confirmation}</p>}
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
